import { FormikProps } from "formik";
import { useCallback, useRef, useState } from "react";
import { RealEstateFormValues } from "../types/realEstateFormValues";

export const useRealEstateFormRef = () => {

  const formikRef = useRef<FormikProps<RealEstateFormValues>>(null);
  const [isFormValid, setIsFormValid] = useState(false)
  const [hasFormChanges, setHasFormChanges] = useState(false)

  const handleValidationChange = useCallback((isValid: boolean) => {
    setIsFormValid(isValid)
  }, [])

  const handleFormChange = useCallback((hasChanges: boolean) => {
    setHasFormChanges(hasChanges)
  }, [])

  return {
    formikRef,
    isFormValid,
    handleValidationChange,
    hasFormChanges,
    handleFormChange,
  };
};
